import { Component, Input, OnInit } from '@angular/core';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { PortalService } from 'projects/brn-frontend/src/app/core/services/portal.service';
import { BotState } from 'projects/brn-frontend/src/app/core/store/bot/bot.state';
import { Person } from 'projects/brn-frontend/src/app/features/bot/modules/bot-crm/store';
import { ChatMessage, ChatSelectors } from '../../store';

@Component({
  selector: 'brn-chat-widget-message',
  templateUrl: './chat-widget-message.component.html',
  styleUrls: ['./chat-widget-message.component.scss'],
})
export class ChatWidgetMessageComponent implements OnInit {
  @SelectSnapshot(BotState.botImage)
  botImage!: string;

  @ViewSelectSnapshot(ChatSelectors.infoMode)
  infoMode!: boolean;

  @SelectSnapshot(BotState.getBotId)
  botId!: string;

  @Input()
  message!: ChatMessage;

  @Input()
  person!: Person;

  constructor() {}

  ngOnInit(): void {}

  // ----------------- Getters ------------------

  get author(): string {
    return this.message.author;
  }
  get defaultAvatar(): { client: string; bot: string } {
    return {
      client: 'https://api.brn.ai/img/default-client-avatar.png',
      bot: 'https://api.brn.ai/img/default-bot-image.png',
    };
  }
  get authorAvatar(): string {
    switch (this.author) {
      case 'bot':
        if (this.message.source && this.message.source.type === 'user') {
          return this.message.source.user.avatar || this.defaultAvatar.bot;
        } else {
          return this.botImage || this.defaultAvatar.bot;
        }
      case 'client':
        return this.person.profile.image || this.defaultAvatar.client;
      default:
        return this.defaultAvatar.bot;
    }
  }

  get scenarioUrl(): string {
    const base = PortalService.Settings.url;
    const scenarioId = this.message.source.scenario.scenario_id;
    return `${base}/bot/${this.botId}/edit-scenario/${scenarioId}`;
  }

  get broadcastUrl(): string {
    const base = PortalService.Settings.url;
    const broadcastId = this.message.source.broadcast.broadcast_id;
    return `${base}/bot/${this.botId}/broadcast/${broadcastId}`;
  }

  get intentUrl(): string {
    const base = PortalService.Settings.url;
    const intentId = this.message.source.intent.intent_id;
    return `${base}/bot/${this.botId}/learning/intents/${intentId}`;
  }

  get sendStatus(): string {
    const status = this.message.send;
    if (!status) {
      return 'send';
    }
    switch (true) {
      case status.read:
        return 'read';
      case status.delivered && !status.read:
        return 'delivered';
      case !status.delivered && !status.read:
        return 'send';
      case status.pending === false || !status.delivered:
        return 'error';
      default:
        return 'send';
    }
  }

  indexColor(index: number): string {
    switch (true) {
      case !index:
        return 'index--NaN';
      case index <= 33:
        return 'index--red';
      case index <= 66:
        return 'index--yellow';
      case index > 66:
        return 'index--green';
      default:
        return 'index--NaN';
    }
  }

  onAvatarNotFound(event: any): void {
    if (event.target && this.author === 'client') {
      event.target.src = this.defaultAvatar.client;
    } else {
      event.target.src = this.defaultAvatar.bot;
    }
  }
}
